import { useVideoCtx } from '../videoContext';

export default function useAnnotationVideo() {
  return useVideoCtx();
}
